import { useMemo } from "react";
import { useUser } from "context/UserContext";
import useGraphQLQuery from "hooks/api/GQL";
import queryConfig from "hooks/api/GQL/queryConfig";
import { IProjectPermissions } from "models/permissions.models";
import { DEFAULT_PROJECT_PERMISSIONS } from "utils/constants/permissions.constants";
import {
  projectConfiguration,
  TProjectConfiguration,
} from "./utils/projectConfiguration";

export type TPermissions = IProjectPermissions & TProjectConfiguration;

type TUsePermissions = {
  permissions: TPermissions;
  isLoading: boolean;
};

export const usePermissions = (projectId: string): TUsePermissions => {
  const { user } = useUser();

  const { data: permissions, isLoading } = useGraphQLQuery({
    ...queryConfig.projectPermissions,
    variables: {
      projectId,
      orgType: user?.organization?.type,
    },
    queryOptions: {
      ...queryConfig.projectPermissions.queryOptions,
      enabled: !!projectId,
    },
  });

  return useMemo(
    () => ({
      permissions: {
        ...(permissions ?? DEFAULT_PROJECT_PERMISSIONS),
        ...projectConfiguration,
      },
      isLoading,
    }),
    [permissions, isLoading],
  );
};
